
import React, { useState, useRef, useEffect, useContext } from 'react';
import { usePersistedState } from '../../../hooks'
import AuthContext from "../../../contexts/Auth";
import EmpresaContext from '../../../contexts/Empresa'
import api from "../../../services/api";
import NotificationAlert from "react-notification-alert";
import Table from './Table'
import Filters from './Filters'

import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    Row,
    Col,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    UncontrolledTooltip
} from "reactstrap";

import SimpleHeader from '../../../components/Headers/SimpleHeader'

export default ({ ...props }) => {

    const { empresaSelecionada } = useContext(EmpresaContext)
    const { hasPermission, hasRole } = useContext(AuthContext)
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = usePersistedState('page', 1)
    const [currentPerPage, setCurrentPerPage] = usePersistedState('perPage', 10)
    const [artigos, setArtigos] = useState([])
    const [alert, setAlert] = useState(null)
    const [pageProperties, setPageProperties] = useState({
        total: "0",
        perPage: currentPage,
        page: currentPerPage,
        lastPage: 1,
        loading: false,
        sort: new Map([])
    })
    const [lastSearch, setLastSearch] = useState({})
    const notificationAlert = useRef();

    const notify = (type, msg) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
                    <span data-notify="message">
                        {msg}
                    </span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 7
        };
        if (notificationAlert) notificationAlert.current.notificationAlert(options);
    };

    const onNewClicked = (e) => {
        e.preventDefault();
        props.history.push('/admin/artigos/new')
    }

    async function updatePageProperties(response) {
        const { total, perPage, page, lastPage } = await response.data
        setPageProperties({
            ...pageProperties,
            total,
            perPage,
            page,
            lastPage,
            loading: false,
        })
    }

    async function loadArtigos(page = 1,
        limit = 10,
        sortField = "(data_publicacao, created_at)",
        sortOrder = "desc",
        filters = lastSearch) {
        setCurrentPage(page)
        setCurrentPerPage(limit)

        try {
            setPageProperties({
                ...pageProperties,
                loading: true
            })
            const response = await api.get(`common/empresas/${empresaSelecionada?.id}/artigos`, {
                params: {
                    page,
                    limit,
                    sortField,
                    sortOrder,
                    ...filters
                }
            })
            setArtigos(response.data)
            await updatePageProperties(response)
        } catch (err) {
            notify('danger', 'Houve um problema ao carregar os artigos.');
        }
    }

    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder, ...props }) => {
        try {
            if (type == 'sort') {
                const value = pageProperties.sort.get(sortField)
                const newOrder = (value || 'asc') == 'desc' ? 'asc' : 'desc'
                const map = pageProperties.sort
                map.set(sortField, newOrder)
                sortOrder = newOrder
            }
            await loadArtigos(page == 0 ? 1 : page, sizePerPage, sortField, sortOrder)
        } catch (error) {
            console.error(error)
            notify('danger', 'Houve um problema ao carregar os artigos.');
        }
    }

    const AdditionalOptions = ({
        hasPermission }) => {

        const [menu, setMenu] = useState([])

        useEffect(() => {
            createDropMenus()
        }, [])

        function createDropMenus() {
            const menus = []
            setMenu(menus)
        }

        return (<>
            {
                menu.length > 0 &&
                <UncontrolledDropdown group size='sm' direction='down'>
                    <DropdownToggle color="link">
                        <i className="fas fa-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu right>
                        {menu}
                    </DropdownMenu>
                </UncontrolledDropdown>
            }

        </>
        )
    }



    return (
        <>
            {alert}
            <div className="rna-wrapper">
                <NotificationAlert ref={notificationAlert} />
            </div>
            <SimpleHeader name="Listagem de artigos" parentName="Artigos" {...props} />
            <div className="w-100">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 100,
                                }}>
                                <Filters
                                    title={<h1>Artigos</h1>}
                                    data={artigos}
                                    presets={() => (
                                        <>
                                            <Button
                                                id="tooltip0983764373524743"
                                                disabled={empresaSelecionada?.id == 0 ? true : false}
                                                color="primary"
                                                type="button"
                                                onClick={e => onNewClicked(e)}
                                                size="sm">
                                                <span className="btn-inner--icon">
                                                    <i className="ni ni-fat-add" />
                                                </span>
                                                Novo Artigo
                                            </Button>

                                            {empresaSelecionada?.id == 0 && (
                                                <UncontrolledTooltip
                                                    delay={0}
                                                    placement="bottom"
                                                    target="tooltip0983764373524743">
                                                    Primeiro selecione uma empresa...
                                                </UncontrolledTooltip>
                                            )}

                                            <AdditionalOptions
                                                hasPermission={hasPermission}
                                                publicacoes={artigos}
                                            />
                                        </>
                                    )}
                                    load={(filters, clearPagination) => {
                                        setLastSearch(filters)
                                        loadArtigos(
                                            clearPagination ? 1 : currentPage,
                                            clearPagination ? 10 : currentPerPage,
                                            "(data_publicacao, created_at)",
                                            "desc",
                                            filters)
                                    }}
                                    notify={notify}
                                />
                            </CardHeader>
                            <CardBody>

                                <Row>
                                    <Col>
                                        <Table
                                            artigos={artigos ? artigos.data : []}
                                            notify={notify}
                                            onTableChange={handleTableChange}
                                            history={props.history}
                                            pageProperties={pageProperties}
                                            loading={loading}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}
